import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import userReducer from './slices/user';
import calendarReducer from './slices/calendar';
import { baseApi } from './api/base';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  user: userReducer,
  calendar: calendarReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export { rootPersistConfig, rootReducer };
